export default __webpack_public_path__ + "static/media/Hello2.4153fede.mp3";